<template>
  <router-view/>
</template>

<style lang="scss">
	// html{
	// 	font-size: 14px; /* 1rem = 16px */
	// }
	// /* 小屏幕适配 */
	// @media screen and (max-width: 320px) {
	//   html {
	//     font-size: 14px;
	//   }
	// }
	
	// /* 中等屏幕 */
	// @media screen and (min-width: 376px) and (max-width: 768px) {
	//   html {
	//     font-size: 20px;
	//   }
	// }
	
	// /* 大屏幕 */
	// @media screen and (min-width: 769px) and (max-width: 1024px) {
	//   html {
	//     font-size: 22px;
	//   }
	// }
	
	// /* 超大屏幕 */
	// @media screen and (min-width: 1025px) {
	//   html {
	//     font-size: 224px;
	//   }
	// }
	body{
		background: #F4F6FA;
		margin: 0;
		/* 滚动条的整体宽度 */
		&::-webkit-scrollbar {
		    width: 5px; /* 或者其他你想要的宽度 */
		    height: 5px; /* 或者其他你想要的宽度 */
		}
		
		/* 滚动条的轨道 */
		&::-webkit-scrollbar-track {
		    background: transparent; /* 轨道的颜色 */
		}
		
		/* 滚动条上的滑块 */
		&::-webkit-scrollbar-thumb {
		    background: #999; /* 滑块的颜色 */
		    border-radius: 4px; /* 滑块的圆角 */
		}
		
		/* 滑块在鼠标悬停时的样式 */
		&::-webkit-scrollbar-thumb:hover {
		    background: #666; /* 滑块在悬停时的颜色 */
		}
	}
	div{
		/* 滚动条的整体宽度 */
		&::-webkit-scrollbar {
		    width: 5px; /* 或者其他你想要的宽度 */
		    height: 5px; /* 或者其他你想要的宽度 */
		}
		
		/* 滚动条的轨道 */
		&::-webkit-scrollbar-track {
		    background: transparent; /* 轨道的颜色 */
		}
		
		/* 滚动条上的滑块 */
		&::-webkit-scrollbar-thumb {
		    background: #999; /* 滑块的颜色 */
		    border-radius: 4px; /* 滑块的圆角 */
		}
		
		/* 滑块在鼠标悬停时的样式 */
		&::-webkit-scrollbar-thumb:hover {
		    background: #666; /* 滑块在悬停时的颜色 */
		}
	}
	/* 文字溢出1行显示 */
	.text_over1{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1; 
		word-wrap:break-word;
		word-break:break-all;
	}
	/* 文字溢出1行显示-2 */
	.text_over1_2{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	/* 文字溢出2行显示 */
	.text_over2{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2; 
		word-wrap:break-word;
		word-break:break-all;
	}
</style>
